import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import Questao from "../../components/Questao";
import { Skeleton, Empty } from "antd";
import BarraHistorico from "../../components/BarraHistorico";
import { Helmet } from "react-helmet";
import { getQuestao } from "../../actions/Questoes.action";
import ReactGa from "react-ga";
import { GA_TRACKING_ID } from "../../configs/config";
/* import MaisQuestoes from "./maisquestoes"; */

import BarraPesquisa from "../../components/BarraPesquisa";

function QuestaoID({ match }) {
  const dispatch = useDispatch();

  window.scrollTo(0, 0);
  const { id } = match.params;

  const { questao, loadQuestoes } = useSelector((state) => state.questoes);

  useEffect(() => {
    ReactGa.initialize(GA_TRACKING_ID);
    ReactGa.pageview("/questoes/" + id);
    dispatch(getQuestao(id));
  }, [id, dispatch]);

  function renderHeader(questao) {
    var div = document.createElement("div");
    div.innerHTML = questao.enunciado;
    var text = div.innerText.replace(/\s\s+/g, " ").trim();

    // Limita tamanho para SEO (title ~60 chars, description ~155 chars)
    const maxTitle = 55;
    const maxDesc = 155;
    const titleSuffix = " | Cadê Direito";
    const titleBase = text.length > maxTitle ? text.slice(0, maxTitle) + "…" : text;
    const titleFull = `Questão: ${titleBase}${titleSuffix}`;
    const description = text.length > maxDesc ? text.slice(0, maxDesc) + "…" : text;

    const baseUrl =
      typeof window !== "undefined" ? window.location.origin : "";
    const canonical = baseUrl
      ? `${baseUrl}/questoes/${questao.url || questao.id}`
      : "";

    // Schema.org JSON-LD para bots de IA e Google
    let aboutName = "";
    if (questao.concurso) {
      const parts = [];
      if (questao.concurso.orgao && questao.concurso.orgao.nome) parts.push(questao.concurso.orgao.nome);
      if (questao.concurso.nome) parts.push(questao.concurso.nome);
      if (questao.concurso.ano) parts.push(String(questao.concurso.ano));
      aboutName = parts.join(" - ");
    }
    const schemaQuestion = {
      "@context": "https://schema.org",
      "@type": "Question",
      name: titleFull,
      text: text,
      url: canonical,
      author: {
        "@type": "Organization",
        name: "Cadê Direito",
      },
    };
    if (aboutName) {
      schemaQuestion.about = { "@type": "Thing", name: aboutName };
    }
    // Escapa </script> para evitar quebra no HTML
    const schemaJson = JSON.stringify(schemaQuestion).replace(/<\//g, "\\u003c/");

    return (
      <Helmet>
        <title>{titleFull}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href={canonical} />

        <meta property="og:title" content={titleFull} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Cadê Direito" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={titleFull} />
        <meta name="twitter:description" content={description} />

        <script type="application/ld+json">{schemaJson}</script>
      </Helmet>
    );
  }

  const title = questao && questao.cdid ? questao.cdid : "";
  return (
    <>
      <div className="container">
        <BarraHistorico title={title} match={match} />
        {!loadQuestoes ? (
          questao && questao.id ? (
            <>
              {renderHeader(questao)}
              <Questao key={questao.id} questao={questao}></Questao>
              <BarraPesquisa />
              {/*<MaisQuestoes idQuestao={questao.id} assunto={questao.assunto} />*/}
            </>
          ) : (
            <Empty
              description="Questão inexistente."
              style={{ margin: "64px 0 128px 0" }}
            />
          )
        ) : (
          <Skeleton active paragraph={{ rows: 12 }}></Skeleton>
        )}
      </div>
    </>
  );
}

export default withRouter(QuestaoID);
